<template>
    <v-container>
        <v-layout
                wrap
        >
            <v-flex
                    mb-5
                    xs12
            >
                <v-row>
                    <v-col class="ma-0 pa-0">
                        <h2 class="headline font-weight-bold mt-5 ml-5">Tijdlijn</h2>
                    </v-col>
                    <v-col>
                    </v-col>
                    <v-col></v-col>
                    <v-col></v-col>
                    <v-col class="ma-0 pa-0 justify-end">
                        <i class="material-icons mt-6 mr-5" @click="dialog=true">filter_list</i>

                    </v-col>

                </v-row>



                <v-list justify-center >
                    <div
                            v-for="(alarm, i) in getFilteredAlarms()"
                            :key="i"
                    >
                        <div v-if="alarm.divider">
                            <v-subheader>{{alarm.text}}</v-subheader>
                            <v-divider></v-divider>
                        </div>
                        <v-card
                                v-else
                                class="rounded-card"
                                style="border-radius:15px; height:110px"
                                outlined
                                @click="visitTimelineItem(alarm.log_filter_id, )"

                        >
                            <v-row>
                                <v-col cols="auto">
                                    <v-img v-if="alarm.type === 'alert' && alarm.completed"
                                           src="./../assets/alarm_handled.png"
                                           style="margin-left:9px"
                                           height="60px"
                                           width="60px"
                                    />
                                    <v-img v-if="alarm.type === 'alert' && !alarm.completed"
                                           src="./../assets/alarm_pending.png"
                                           style="margin-left:9px"
                                           height="60px"
                                           width="60px"
                                    />
                                    <v-img v-if="alarm.type === 'notification' && alarm.completed"
                                           src="./../assets/notification_handled.png"
                                           style="margin-left:9px"
                                           height="60px"
                                           width="60px"
                                    />
                                    <v-img v-if="alarm.type === 'notification' && !alarm.completed"
                                           src="./../assets/notification_pending.png"
                                           style="margin-left:9px"
                                           height="60px"
                                           width="60px"
                                    />

                                    <v-img v-if="alarm.type === 'info' && alarm.completed"
                                           src="./../assets/event_handled.png"
                                           style="margin-left:9px"
                                           height="60px"
                                           width="60px"
                                    />
                                    <v-img v-if="alarm.type === 'info' && !alarm.completed"
                                           src="./../assets/event_pending.png"
                                           style="margin-left:9px"
                                           height="60px"
                                           width="60px"
                                    />
                                </v-col>
                                <v-col cols="auto">
                                    <v-card-title class="pa-1">
                                        {{shorten(alarm.name)}}
                                    </v-card-title>
                                    <v-card-subtitle class="pa-1">Aangenomen door: {{alarm.acceptee}}</v-card-subtitle>
                                    <v-card-description class="pa-1">{{convertTimestamp(alarm.timestamp)}}</v-card-description>
                                    <pre></pre>

                                </v-col>

                            </v-row>

                        </v-card>
                    </div>

                </v-list>
            </v-flex>
        </v-layout>
        <div>
            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Filters</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                                :items="getAlarmNames()"
                                                label="Alarmnaam"
                                                v-model="alarmfilter"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                                :items="getMonteurs()"
                                                label="Monteur"
                                                v-model="monteur"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Opslaan</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </div>
    </v-container>
</template>

<script>

    //import axios from "axios";

    import axios from "axios";
    import config from "@/config/config";

    export default {
        data: () => ({
            alarms: [],
            monteur: undefined,
            alarmfilter: undefined,
            dialog: false

        }),
        methods: {
            getMonteurs() {
                const unique = [...new Set(this.alarms.map(item => item.acceptee))];
                let filtered = unique.filter(function (el) {
                    return el != null && el !== undefined;
                });
                filtered.unshift("Geen filter")
                return filtered;
            },
            getFilteredAlarms() {
                let result = this.alarms
                if(this.monteur && this.monteur !== "Geen filter") {
                    result = result.filter(x => x.acceptee === this.monteur)
                }
                if (this.alarmfilter && this.alarmfilter !== "Geen filter") {
                    result = result.filter(x => x.name === this.alarmfilter)
                }
                return result;
             },
            getAlarmNames() {
                const unique = [...new Set(this.alarms.map(item => item.name))];
                let filtered = unique.filter(function (el) {
                    return el != null && el !== undefined;
                });
                filtered.unshift("Geen filter")
                return filtered;
            },
            visitTimelineItem(filter) {
                this.$router.push({name: 'timelineItem', query: {filter: filter}});
            },
            shorten(string) {
                let short = string.replace(/(.{18})..+/, "$1..");
                return short;
            },

            convertTimestamp(ts) {
                let date = new Date(ts)
                let today = new Date()
                if(date.getDate() < today.getDate()) {
                    if (date.getMinutes() < 10 && date.getHours() < 10) {
                        return "0" + date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
                    } else if(date.getMinutes() < 10) {
                        return date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
                    } else if(date.getHours() < 10) {
                        return "0" + date.getHours()+":" + date.getMinutes()+ " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
                    }
                    return date.getHours() + ":" + date.getMinutes() + " (" + date.getDate() + "/" + (date.getMonth()+1) + ")"
                }
                if (date.getMinutes() < 10 && date.getHours() < 10) {
                    return "0" + date.getHours() + ":0" + date.getMinutes()
                } else if(date.getMinutes() < 10) {
                    return date.getHours() + ":0" + date.getMinutes()
                } else if(date.getHours() < 10) {
                    return "0" + date.getHours()+":" + date.getMinutes()
                }
                return date.getHours() + ":" + date.getMinutes()
            },
            getTimeDifference(ts) {
                let timestamp = new Date(ts)
                let now = new Date()

                let diff = now.getTime() - timestamp.getTime(); // this is a time in milliseconds
                let diff_as_date = new Date(diff);
                diff_as_date.getHours(); // hours
                diff_as_date.getMinutes(); // minutes
                diff_as_date.getSeconds(); // seconds
                const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds


                const diffDays = Math.round(Math.abs((timestamp - now) / oneDay));
                if(diffDays === 1) {
                    return "Gisteren"
                } else if(diffDays === 2) {
                    return "2 dagen geleden"
                } else if (diffDays > 2){
                    return "Meer dan 2 dagen geleden"
                } else {
                    let hours = diff_as_date.getHours()
                    let minutes = diff_as_date.getMinutes()
                    if(hours !== 0) {
                        hours--
                    }
                    return  hours + " uur en " + minutes + " minuten geleden"
                }
            },
            alternative() {
                this.$router.push({path: 'alternative'});
            },
            getSteps(alarm) {
                let max = alarm.workflow.length;
                let finished = 0;
                for(let i = 0; i < max; i++) {
                    if(alarm.workflow[i].completed) {
                        finished++
                    }
                }

                return "Stap " + finished + " van de " + max + "."
            }
        },
        mounted () {
            axios
                .post(config.url +'/alarms/history')
                .then(response => (this.alarms = response.data.alarms))
            window.scrollTo(0,0);
        }

    };
</script>

<style scoped lang="css">
    .rounded-card{
        border-radius:50px;
        margin: 5px;
        background: #ffffff;
        border-color: grey;
    }
    v-img {
        padding: 50px;
    }

    .v-subheader {
        height: 32px !important;
    }

    .v-text-field--box .v-input__slot, .v-text-field--outline .v-input__slot{
        max-width: 40px!important;
        display: flex!important;
        align-items: center!important
    }


</style>

